import VideoChallengeData from "./VideoChallengeData";
import LayoutContainer from "../../components/Containers/LayoutContainer";

const Video_Challenge = () => {
  return (
    <LayoutContainer title="Video Challenge">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Video Challenge Data
        </h2>
      </div>
      <VideoChallengeData />
    </LayoutContainer>
  );
};

export default Video_Challenge;
